// Smart Daara - School Not Found Page
// Rendered when a user visits `/<slug>` and the tenant doesn't exist.

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { School, ArrowLeft, Search } from 'lucide-react';

export default function SchoolNotFoundPage({ slug }) {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const t = (fr, en) => language === 'fr' ? fr : en;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-amber-50/40 flex flex-col items-center justify-center p-6" data-testid="school-not-found-page">
      <div className="max-w-md text-center space-y-6">
        <div className="w-24 h-24 mx-auto rounded-full bg-white shadow-md flex items-center justify-center">
          <Search className="w-10 h-10 text-slate-400" />
        </div>
        <div>
          <h1 className="text-3xl font-outfit font-bold text-slate-900 mb-2">
            {t('École introuvable', 'School not found')}
          </h1>
          <p className="text-slate-600">
            {t(
              `Aucune école n'est enregistrée sous le nom `,
              'No school registered under the name '
            )}
            <span className="font-mono text-emerald-700 font-semibold">/{slug}</span>.
          </p>
          <p className="text-sm text-slate-500 mt-3">
            {t(
              "Vérifiez l'URL avec votre administrateur ou explorez notre plateforme.",
              'Check the URL with your administrator or explore our platform.'
            )}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            data-testid="not-found-back-btn"
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('Retour', 'Go back')}
          </Button>
          <Button
            asChild
            className="bg-emerald-700 hover:bg-emerald-800 gap-2"
            data-testid="not-found-home-btn"
          >
            <Link to="/home">
              <School className="w-4 h-4" />
              {t('Découvrir Smart Daara', 'Discover Smart Daara')}
            </Link>
          </Button>
        </div>
        <div className="pt-4 border-t border-slate-200">
          <Link to="/login" className="text-sm text-emerald-700 hover:underline">
            {t('Se connecter à mon compte', 'Sign in to my account')}
          </Link>
        </div>
      </div>
    </div>
  );
}
